module.exports = __webpack_public_path__ + "img/c05_buildingtechspqr_Normal_ua.4ae03007.webp";